import type { AppConfig } from "@product/rosetta-sdk";
import { useAsync, useMountEffect } from "@react-hookz/web";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import { config } from "shared/data";

import type { rosettaConfigAppConfigQuery } from "scmp-app/queries/__generated__/rosettaConfigAppConfigQuery.graphql";

export const useRosettaConfig = () => {
  const environment = useRelayEnvironment();
  const [state, actions] = useAsync(async () => {
    const data = await fetchQuery<rosettaConfigAppConfigQuery>(
      environment,
      graphql`
        query rosettaConfigAppConfigQuery {
          appConfig(filter: { entityId: "rosetta" }) {
            json
          }
        }
      `,
      {},
      {
        fetchPolicy: "store-or-network",
      },
    ).toPromise();

    if (!data?.appConfig?.json) return;
    const raw = data.appConfig.json as {
      dev: AppConfig;
      production: AppConfig;
    };
    switch (config.general.env) {
      case "preprod":
      case "production":
        return raw.production;
      default:
        return raw.dev;
    }
  });

  useMountEffect(() => {
    void actions.execute();
  });

  return { rosettaConfigState: state };
};
